import { createContext, useContext } from 'react'
import type { AuthMode } from '@/lib/config'

export type DevRole = 'admin' | 'editor' | 'viewer'
export const DEV_ROLES: DevRole[] = ['admin', 'editor', 'viewer']

export interface AuthAccount {
  name: string
  username: string
}

export interface AuthContextValue {
  mode: AuthMode
  account: AuthAccount
  signOut: () => void
  /** Dev mode only: the impersonated role, sent as X-Dev-Role. */
  devRole?: DevRole
  setDevRole?: (role: DevRole) => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

/** The signed-in account and auth controls. Only valid inside <AuthProvider>. */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
